export default "__VITE_ASSET__Cl94aXCk__"